'use client'

import { useEffect, useState } from 'react'

import { SKELETON_LOADING_DELAY_MS } from '../core.const'

export function useDelayedSkeletonLoading(isLoading: boolean, delayMs: number = SKELETON_LOADING_DELAY_MS): boolean {
  const [showSkeleton, setShowSkeleton] = useState(false)

  useEffect(() => {
    if (!isLoading) {
      setShowSkeleton(false)
      return
    }

    const timeoutId = window.setTimeout(() => {
      setShowSkeleton(true)
    }, delayMs)

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [isLoading, delayMs])

  return showSkeleton
}
